<template>
    <figure class="image is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only" style="margin-top: 30px;">
        <img src="https://assets.webbank.com/newsroom/pr49_hero.png" alt="BMG Money New CRO">
    </figure>
    <figure class="image is-hidden-widescreen">
        <img src="https://assets.webbank.com/newsroom/pr49_small.png" alt="BMG Money New CRO">
    </figure>
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">

                    <router-link class="button is-primary is-small is-pulled-right" to="/newsroom">
                        <span class="icon"><i class="fas fa-arrow-left"></i></span>
                        <span>Back to Newsroom</span>
                    </router-link>
                    <p class="press-release">Press Release</p>
                    <br>
                    <div class="content">
                        <h2 class="news-page-title">BMG Money Appoints Allyson Torsak as New Chief Revenue Officer</h2>
                        <br>
                        <p><em><small>March 31, 2025</small></em></p>
                        <br>
                        <p><strong>MIAMI, Fla., March 31, 2025</strong> – <a @click="clickOutWarning('https://www.bmgmoney.com/');">BMG Money</a> today announced the appointment of Allyson Torsak as its new Chief Revenue Officer (CRO). Bringing nearly two decades of experience, Torsak will report directly to CEO Kieran Noonan and help align sales and marketing to drive profitability and growth.</p>
                        <p>Before joining BMG Money, Ms. Torsak's experience was spent at leading financial lending institutions, including Regions Bank (fka EnerBank USA) where she served as Senior Vice President of Strategy for the Home Improvement Lending Division. Prior to that, she spent nearly eight years at WebBank, where she served as Vice President of Business Development, managing a team responsible for development of strategic opportunities and partnerships for the Bank, driving increased revenue and delivering on strategic initiatives for the Bank. Ms. Torsak spent nearly four years at Goldman Sachs working in Credit Risk Management & Advisory and four years at Merrill Bank, servicing in both risk and operations roles.  Allyson holds an MBA from Thunderbird School of Global Management and a BA from the University of Utah. She also serves on the Board of Trustees and the Financial Literacy Committee of Utah Youth Village.</p>
                        <p>"Allyson's strong background in leadership, strategy, negotiations and business development will be a great addition to our team," said Noonan. "I look forward to working with her to see what her skill set will bring to BMG Money and the ideas she provides to help our company grow."</p>
                        <p>Torsak joins BMG Money as the company continues its market expansion and strengthens its commitment to providing responsible financial solutions to employees across the country.</p>
                        <br>
                        <p><strong>About BMG Money</strong></p>
                        <p>Headquartered in Miami, FL, BMG Money has offered employment-based lending solutions since 2011 to help public and private sector employees that have been overlooked by traditional financial institutions and are struggling to overcome archaic methods of determining credit worthiness. Currently operating in 39 states plus the District of Columbia, BMG Money's mission is to enhance the financial wellness of its customers through a combination of financial education, credit monitoring solutions, and emergency loans, providing the tools necessary for a secure financial future. For more information, please visit <a @click="clickOutWarning('https://www.bmgmoney.com/');">www.bmgmoney.com</a>.</p>
                        <br>
                    </div>

                    <div class=" modal" :class="{ 'is-active': clickout_modal }">
                        <div class="modal-background"></div>
                        <div class="modal-content">
                            <div class="box">
                                <h2 class="box-title">You are leaving our site!</h2>
                                <br>
                                <p>You will be linking to another website not owned or operated by WebBank.</p>
                                <br>
                                <p>WebBank is not responsible for the availability or content of this website
                                    and does not represent either the linked website or you, should you enter into a
                                    transaction.</p>
                                <br>
                                <p>The inclusion of any hyperlink does not imply any endorsement, investigation,
                                    verification or monitoring by WebBank of any information in any hyperlinked
                                    site. We encourage you to review their privacy and security policies which may differ
                                    from WebBank.</p>
                                <br>
                                <p>If you click &quot;Proceed&quot;, the link will open in a new window.</p>
                                <br>
                                <br>
                                <div class="field is-grouped">
                                    <div class="control">
                                        <button class="button is-link" @click="doClickout">Proceed</button>
                                    </div>
                                    <div class="control">
                                        <button class="button is-link is-light"
                                            @click="clickout_modal = false">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

    created() {
        document.title = "BMG Money New CRO";
    },

    data: function () {
        return {
            clickout_modal: false,
            clickout_url: null,
        }
    },

    methods: {
        clickOutWarning: function (url) {
            this.clickout_url = url;
            this.clickout_modal = true;
        },


        doClickout: function () {
            this.clickout_modal = false;
            window.open(this.clickout_url, "_blank");
        },
    }
}
</script>
